import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { GroupForm } from "@univdiam/ui/customComponents/GroupList/GroupForm"
// import api from '@/http/api'
import axios from "axios"

const API_BASE_URL = import.meta.env.VITE_SERVER_URL

export default function GroupAdd() {

  const navigate = useNavigate()
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleAddGroup = async (data: any) => {
    setIsSubmitting(true)
    try {
      const response = await axios.post(`${API_BASE_URL}/api/groups/add`, data)

      if (response.status === 201 || response.status === 200) {
        alert("Group created successfully!")
        navigate("/Group")
      }
    } catch (error: any) {
      console.error("Error creating group:", error)
      const message = error.response?.data?.error || error.response?.data?.message || "Failed to create group.";
      alert(message)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <div className="p-6 max-w-2xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Create New Group</h1>
      <GroupForm onSubmit={handleAddGroup} isSubmitting={isSubmitting} />
    </div>
  )
}
